if (!customElements.get('anbernic-testimonials')) {
  customElements.define('anbernic-testimonials', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
      this.viewport = this.querySelector('[data-review-viewport]');
      this.controls = this.querySelector('[data-review-controls]');
      this.pauseButton = this.querySelector('[data-review-pause]');
      this.status = this.querySelector('[data-review-status]');
      if (!this.slides.length) return;

      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionOverride = false;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.classList.add('anbernic-reviews--ready');
      if (this.controls) this.controls.hidden = false;

      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index, true), options));
      this.pauseButton?.addEventListener('click', () => {
        if (this.motion.matches && !this.motionOverride) {
          this.motionOverride = true;
          this.paused = false;
        } else this.paused = !this.paused;
        this.updatePauseButton();
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        this.dots[this.index]?.focus();
      }, options);
      this.viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        this.pointerStart = { x: event.clientX, y: event.clientY };
      }, options);
      this.viewport.addEventListener('pointerup', (event) => {
        if (!this.pointerStart) return;
        const x = event.clientX - this.pointerStart.x;
        const y = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(x) >= 35 && Math.abs(x) > Math.abs(y)) this.select(this.index + (x < 0 ? 1 : -1), true);
      }, options);
      this.viewport.addEventListener('pointercancel', () => { this.pointerStart = null; }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { this.motionOverride = false; this.updatePauseButton(); this.schedule(); }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex((slide) => slide.dataset.reviewBlockId === event.detail?.blockId || slide.contains(event.target));
        if (index < 0) return;
        this.paused = true;
        this.select(index, true);
        this.updatePauseButton();
      }, options);

      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.1 });
      this.observer.observe(this);
      this.select(0);
      this.updatePauseButton();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.abortController?.abort();
      this.observer?.disconnect();
    }

    select(index, manual = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        let distance = (slideIndex - this.index + this.slides.length) % this.slides.length;
        if (distance > this.slides.length / 2) distance -= this.slides.length;
        slide.style.setProperty('--review-offset', distance);
        slide.dataset.state = distance === 0 ? 'active' : Math.abs(distance) === 1 ? 'neighbor' : 'inactive';
        slide.setAttribute('aria-hidden', String(distance !== 0));
      });
      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (manual && this.status) this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.schedule();
    }

    updatePauseButton() {
      if (!this.pauseButton) return;
      const stopped = this.paused || (this.motion.matches && !this.motionOverride);
      this.pauseButton.setAttribute('aria-label', stopped ? '自動再生を開始' : '自動再生を停止');
      this.pauseButton.querySelector('span').textContent = stopped ? '▶' : 'Ⅱ';
    }

    schedule() {
      window.clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || (this.motion.matches && !this.motionOverride) || this.hovered || this.focused || !this.visible || document.hidden) return;
      this.timer = window.setTimeout(() => this.select(this.index + 1), Math.max(3000, Number(this.dataset.interval) || 5000));
    }
  });
}
